
import { defineComponent, PropType, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import { FoodItem, RecoginitionList, IngredientList } from "@/types/pantry";
import SelectingIngredientList from "@/components/common/SelectingIngredientList.vue";
import { SelectingIngredientListDataItem } from "@/types/common";
import PantryIngredientEmptyView from "./PantryIngredientEmptyView.vue";
import PantryCategoryTitleView from "./PantryCategoryTitleView.vue";
import PantryIngredientCameraEmptyView from "./PantryIngredientCameraEmptyView.vue";
import PantryFoodItem from "./PantryFoodItem.vue";
export default defineComponent({
  name: "PantryIngredientCameraListView",
  components: {
    SelectingIngredientList,
    PantryIngredientEmptyView,
    PantryCategoryTitleView,
    PantryIngredientCameraEmptyView,
    PantryFoodItem
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    recoginitionCheckList: {
      type: IngredientList,
      default: null,
      required: true
    },
    recoginitionList: {
      type: RecoginitionList,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const onSelectIngredient = (id: number, name: string,  isSelect: boolean) => {
      NativeClient.sendDebugLog(
        "PantryIngredientCameraListView onSelectIngredient id=" +
          props.id +
          "ingredientId = " +
          id +
          ", name = " +
          name +
          ", isSelect = " +
          isSelect
      );
      context.emit("on-select", props.id, id, name, isSelect);
    };
    const isEmptyRecoginitionCheckList = () => {
      return props.recoginitionCheckList != null && props.recoginitionCheckList.list != null && props.recoginitionCheckList.list.length == 0;
    };
    const isEmptyRecoginitionList = () => {
      return props.recoginitionList != null && props.recoginitionList.list != null && props.recoginitionList.list.length == 0;
    };
    const isEmpty = () => {
      const isEmptyCheck = isEmptyRecoginitionCheckList();
      const isEmpty = isEmptyRecoginitionList();
      return isEmptyCheck && isEmpty;
    };
    const getCheckButtonLabel = () => {
      const isEmpty = isEmptyRecoginitionCheckList();
      return !isEmpty ? "まとめて修正確認する" : null;
    };
    const clickButtonCheckTitle = () => {
      context.emit("click-button-recoginition-check-title");
    };
    const clickButtonTitle = () => {
      context.emit("click-button-recoginition-title");
    };
    const clickButtonCheckItem = (id: number | null, name: string) => {
      NativeClient.sendDebugLog("PantryIngredientCameraListView clickButtonCheckItem id = " + id + " name = " + name);
      context.emit("click-button-recoginition-check-item", id, name);
    };
    const getRecognitionList = () => {
      return props.recoginitionList != null && props.recoginitionList.list != null ? props.recoginitionList.list : null;
    };
    const getRecoginitionCheckList = () => {
      return props.recoginitionCheckList != null && props.recoginitionCheckList.list != null ? props.recoginitionCheckList.list : new Array<SelectingIngredientListDataItem>();
    };
    return {
      isEmpty,
      onSelectIngredient,
      getCheckButtonLabel,
      isEmptyRecoginitionCheckList,
      isEmptyRecoginitionList,
      clickButtonCheckTitle,
      clickButtonTitle,
      clickButtonCheckItem,
      getRecognitionList,
      getRecoginitionCheckList
    };
  }
});
